<template>
	<div class="produto__imagens">
		<ImagemDialog :dialog="dialogImagem" :imgSrc="imgSrc" @dialogClose="dialogImagemClose" />
		<div class="produto__slider">
			<img
				class="produto__imagem-principal"
				v-if="imagens"
				:src="imagens[contadorImagem].url_img"
				@click="imagemSelected(imagens[contadorImagem].url_img)"
			/>
			<div class="produto__desconto" v-if="desconto">{{ desconto }}</div>
			<button
				class="produto__botao-nav-imagens produto__botao-nav-imagens--anterior"
				@click="retornar()"
				v-if="imagens.length > 1"
			>
				<v-icon color="white"> mdi-chevron-left </v-icon>
			</button>
			<button
				class="produto__botao-nav-imagens produto__botao-nav-imagens--proximo"
				@click="avancar()"
				v-if="imagens.length > 1"
			>
				<v-icon color="white"> mdi-chevron-right </v-icon>
			</button>
			<ul class="produto__paginacao" v-if="imagens.length > 1 && !galeria">
				<template v-for="(sku, i) in imagens">
					<li :key="i">
						<div
							class="produto__paginacao-bullet"
							@click="selecionarImagem(i)"
							:class="contornarBulletSelecionado(i)"
						/>
					</li>
				</template>
			</ul>
		</div>
		<ul class="produto__galeria" v-if="imagens.length > 0 && galeria">
			<template v-for="(imagem, i) in imagens">
				<li :key="i" v-if="i < 10">
					<button class="produto__botao-imagem" @click="selecionarImagem(i)">
						<img class="produto__imagem" :src="imagem.url_img" :class="contornarImagemSelecionada(i)" />
					</button>
				</li>
			</template>
		</ul>
		<ul class="produto__paginacao produto__paginacao--mobile" v-if="imagens.length > 1 && galeria">
			<template v-for="(sku, i) in imagens">
				<li :key="i">
					<div
						class="produto__paginacao-bullet"
						@click="selecionarImagem(i)"
						:class="contornarBulletSelecionado(i)"
					/>
				</li>
			</template>
		</ul>
	</div>
</template>
<script>
import ImagemDialog from '../Produto/ImagemDialog.vue'

export default {
	props: {
		imagens: Array,
		galeria: Boolean,
		desconto: String,
		zoom: Boolean,
		abrirImagem: {Type: Boolean, default: true}
	},
	data: function () {
		return {
			contadorImagem: 0,
			dialogImagem: false,
			imgSrc: '',
		}
	},
	components: {
		ImagemDialog,
	},
	computed: {},
	methods: {
		avancar() {
			const quantidadeImagens = this.imagens.length
			if (this.contadorImagem < quantidadeImagens - 1) this.contadorImagem++
			else this.contadorImagem = 0
		},
		retornar() {
			if (this.contadorImagem > 0) this.contadorImagem--
		},
		selecionarImagem(i) {
			this.contadorImagem = i
		},
		contornarImagemSelecionada(i) {
			if (i == this.contadorImagem) return 'produto__imagem--selecionada'
		},
		contornarBulletSelecionado(i) {
			if (i == this.contadorImagem) return 'produto__paginacao-bullet--selecionado'
		},
		dialogImagemClose() {
			this.dialogImagem = false
		},
		imagemSelected(img) {
			if (img != '/img/produto.7e9078e7.png' && this.abrirImagem) {
				this.dialogImagem = true
				this.imgSrc = img
			}
		},
	},
}
</script>

<style scoped>
ul,
li {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.produto__imagens {
	width: 100%;
	margin: 0;
}

.produto__slider {
	position: relative;
	display: flex;
	justify-content: center;
}

.produto__imagem-principal {
	width: 100%;
	aspect-ratio: 1 / 1;
	object-fit: cover;
	border-radius: 1rem;
	display: block;
}

.produto__desconto {
	width: 100%;
	background-color: var(--v-promocao-base);
	position: absolute;
	top: 0px;
	color: var(--v-textoPromocao-base);
	font-weight: bold;
	text-align: center;
	border-start-end-radius: 0.9rem;
	border-start-start-radius: 0.9rem;
}

.produto__botao-nav-imagens {
	position: absolute;
	width: 40px;
	height: 40px;
	padding: 10px;
	border: none;
	cursor: pointer;
	background: hsla(0, 3%, 42%, 0.502);
	border-radius: 360px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.produto__botao-nav-imagens:hover {
	background: hsla(0, 3%, 42%, 0.8);
}

.produto__botao-nav-imagens--anterior {
	top: 45%;
	left: 2%;
}

.produto__botao-nav-imagens--proximo {
	top: 45%;
	right: 2%;
}

.produto__galeria {
	display: flex;
	align-items: center;
	gap: 10px;
	height: 120px;
	width: 100%;
	overflow-x: auto;
	scrollbar-color: var(--v-primary-base) #d9d9d9;
	scrollbar-width: thin;
}

.produto__botao-imagem {
	width: 97px;
	height: 97px;
	border-radius: 13px;
	margin: 0;
	display: block;
}

.produto__botao-imagem:focus {
	outline-color: #6d6767;
}

.produto__imagem {
	width: 97px;
	height: 97px;
	border-radius: 13px;
	margin: 0;
	object-fit: cover;
	aspect-ratio: 1 / 1;
}

.produto__imagem:not(.produto__imagem--selecionada):hover {
	border: 2px solid #6d6767;
	padding: 2px;
}

.produto__imagem--selecionada {
	border: 3px solid #6d6767;
}

.produto__paginacao {
	justify-content: center;
	gap: 1rem;
	margin-bottom: 0.5rem;
	display: none;
}

.produto__paginacao-bullet {
	aspect-ratio: 1/1;
	width: 0.5rem;
	background-color: #d9d9d9;
	border-radius: 50%;
}

.produto__paginacao-bullet--selecionado {
	background-color: var(--v-primary-base);
}

.produto__slider .produto__paginacao {
	position: absolute;
	bottom: 0px;
	margin-left: auto;
	margin-right: auto;
	display: flex;
}

::-webkit-scrollbar {
	height: 0.5em;
}

::-webkit-scrollbar-track {
	background: #d9d9d9;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb {
	background: #6d6767;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb:hover {
	background: var(--v-primary-base);
}

@media (max-width: 600px) {
	.produto__paginacao {
		display: flex;
		padding-top: 0.5rem;
	}

	.produto__galeria {
		display: none;
	}
}
</style>